// components/controleBar/mesas/ModalMesaReserva.js
import React, { useState } from 'react';
import { useMesaReserva } from '../../../contexts/controleBar/mesas/MesaReservaContext';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import { ModalBody, ModalHeader } from 'react-bootstrap';
import Input from '../../../components/input/Input';
import ModalFooter from '../../../components/modalForm/ModalFooter';

const ModalMesaReserva = ({ open, onClose, mesaId }) => {
  const { addReserva, reservaSel, setResevaSel } = useMesaReserva();  
  const [dataHora, setDataHora] = useState('');

  if (!open) return null;

  const handleSave = async () => {
    if (!reservaSel.clienteId || !dataHora) return;

    await addReserva({
      clienteId: parseInt(reservaSel.clienteId),
      dataHora: new Date(reservaSel.dataHora),
      mesaId: mesaId // se precisar para uso interno
    });

    // setClienteId('');
    setDataHora(new Date());
    onClose();
  };

  return (
    <ModalContainer show={open}>

      <ModalHeader>
          <h5 className="modal-title">{'Nova Reserva'}</h5>
          <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
      </ModalHeader>
  

      <ModalBody>

        <div className="input-group">
            <Input
                label="Código"
                value={reservaSel.clienteId || ''}
                onChange={(e) => setResevaSel({ ...reservaSel, clienteId: e.target.value })}                
                btnBuscar={(e) => console.log("buscar cliente")}
                btnAdd={(e) => console.log("Add cliente")}
                // onBlur={handleExit}
            />
            <Input
                label="Nome"
                value={reservaSel?.clienteNome}
                onChange={(e) => setResevaSel({ ...reservaSel, clienteNome: e.target.value })}
                size={300}
            />
            
        </div>
        

        <div className="mb-3">
          <label className="block text-sm font-medium">Data e Hora</label>
          <input
            type="datetime-local"
            value={dataHora}            
            onChange={(e) => setResevaSel({ ...reservaSel, dataHora: e.target.value })}  
            className="w-full border p-2 rounded mt-1"
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <div>
          <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
          <button type="button" className="btn btn-primary" onClick={handleSave}>Salvar</button>
        </div>
      </ModalFooter>
      
    
    </ModalContainer>
  );
};

export default ModalMesaReserva;